import apiClient from '../plugins/axios';

class DashboardService {
  async getData(params = {}) {
    try {
      const response = await apiClient.get('/dashboard', { params });
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new DashboardService();
